export default "__VITE_ASSET__BEZVTKp1__"